import {
    BusinessRegistrationDto,
    BusinessRegistrationModel,
} from '../../data-layer/business/types';
import { addProtocol } from '../../utils/addProtocol';

export const toBusinessRegistrationPersistenceDto = (
    model: BusinessRegistrationModel,
): BusinessRegistrationDto => ({
    domain: addProtocol(model.domain),
    instagram_url: model.instagramUrl,
    telegram_url: model.telegramUrl,
    display_name: model.displayName,
    offer_agreement: model.offerAgreement,
    email: model.email,
    send_ad_mails: model.sendAdMails,
});
